/*
 * share_popup - シェアポップアップ
 */
export default function share_popup (btn_sns) {
  if (
    btn_sns != null &&
    {}.toString.call(btn_sns) === '[object String]' &&
    btn_sns.length > 0
  ) {
    const targets = document.querySelectorAll(btn_sns);
    if (targets.length > 0) {
      for (let _this of targets) {
        let option = {
          name: null,
          query: null,
          hashtag: null,
          share_url: null,
          text: null
        };
        option['name'] = _this.getAttribute('data-sns-name');

        if (option['name'] != null) {
          // Disable link
          let href = _this.href;
          if (href != null) {
            _this.href = 'javascript: void 0';
          }

          option['query'] = _this.getAttribute('data-sns-query')
            ? _this.getAttribute('data-sns-query')
            : null;

          if (option['query'] == null) {
            // Share data
            option['share_url'] = _this.getAttribute('data-sns-share_url')
              ? _this.getAttribute('data-sns-share_url')
              : location.href;
            option['hashtag'] = _this.getAttribute('data-sns-hashtag')
              ? _this.getAttribute('data-sns-hashtag')
              : '';
            option['text'] = _this.getAttribute('data-sns-text')
              ? _this.getAttribute('data-sns-text')
              : document.title != null
                ? document.title
                : 'タイトル';
          }

          switch (option['name']) {
            case 'twitter':
              option['query'] =
                option['query'] == null
                  ? `https://twitter.com/share?url=${
                    option['share_url']
                  }&text=${encodeURIComponent(option['text'])}&hashtags=${
                    option['hashtag']
                  }`
                  : `https://twitter.com/share?${decodeURIComponent(
                    option['query']
                  )}`;
              break;
            case 'facebook':
              option['query'] =
                option['query'] == null
                  ? `https://www.facebook.com/sharer/sharer.php?u=${
                    option['share_url']
                  }`
                  : `${decodeURIComponent(option['query'])}`;
              break;
            case 'line':
              option['query'] =
                option['query'] == null
                  ? `http://line.me/R/msg/text/?${option['text']}\n${
                    option['share_url']
                  }`
                  : `http://line.me/R/msg/text/?${decodeURIComponent(
                    option['query']
                  )}`;
              break;
            case 'hatena':
              option['query'] =
                option['query'] == null
                  ? `https://b.hatena.ne.jp/add?mode=confirm&shareUrl=${
                    option['share_url']
                  }&description=${encodeURIComponent(option['text'])}`
                  : `https://b.hatena.ne.jp/add?mode=confirm&${decodeURIComponent(
                    option['query']
                  )}`;
              break;
            case 'google':
              option['query'] =
                option['query'] == null
                  ? `https://plus.google.com/share?shareUrl=${
                    option['share_url']
                  }`
                  : `https://plus.google.com/share?${decodeURIComponent(
                    option['query']
                  )}`;
              break;
          }

          _this.addEventListener('click', function (e) {
            window.open(
              encodeURI(decodeURI(option['query'])),
              'Share-window',
              `height=450, width=650, resizable=yes, status=yes, toolbar=no, menubar=no, location=no`
            );

            e.preventDefault();
            return false;
          });
        }
      }
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./assets/js/util/share_popup.js
// module id = 1
// module chunks = 0